// extracted by mini-css-extract-plugin
export default {"container":"alerter-widget_container__hfgzD","labelContainer":"alerter-widget_labelContainer__pO6OS","content":"alerter-widget_content__Lvets"};